import { usePageView } from '@/shared/application/hooks'

const useAditional = () => {
  usePageView()
}

export { useAditional }
